import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 7 11"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "nonzero",
      d: "M6.333.937c0-.154-.06-.31-.177-.428a.61.61 0 0 0-.856 0L.917 4.893a.62.62 0 0 0-.177.428c0 .153.055.306.177.428l4.378 4.377c.23.246.627.249.861.014a.61.61 0 0 0 0-.856L2.192 5.328l3.964-3.963a.6.6 0 0 0 .177-.428"
    }, null, -1)
  ]))]))
}
export default { render: render }